import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  connect() {
    if (this.element.classList.contains("transition-remove-bg-green-200")) {
      setTimeout(() => {
        this.element.classList.remove("bg-green-200")
      }, 300)
    }
    if (this.element.classList.contains("transition-remove-bg-red-200")) {
      setTimeout(() => {
        this.element.classList.remove("bg-red-200")
      }, 300)
    }
  }
}